<template>
  <div class="month-range">
    <el-date-picker
      key="start"
      v-model="startMoth"
      type="month"
      value-format="yyyy-MM"
      placeholder="选择月"
      :picker-options="startPickerOptions"
    />
    <span class="m-h-8">至</span>
    <el-date-picker
      key="end"
      v-model="endMonth"
      type="month"
      value-format="yyyy-MM"
      placeholder="选择月"
      :picker-options="endPickerOptions"
    />
  </div>
</template>

<script>
import DateUtils from '@/utils/date'

export default {
  name: 'DateMonthRangePicker',

  props: {
    start: {
      type: String,
      default: ''
    },

    end: {
      type: String,
      default: ''
    }
  },

  computed: {
    startMoth: {
      get() {
        return this.start
      },
      set(val) {
        this.$emit('update:start', val)
      }
    },

    endMonth: {
      get() {
        return this.end
      },
      set(val) {
        this.$emit('update:end', val)
      }
    },

    startPickerOptions() {
      return {
        disabledDate: time => {
          return (
            time.getTime() >
            new Date(DateUtils.safeDate(this.endMonth)).getTime()
          )
        }
      }
    },

    endPickerOptions() {
      return {
        disabledDate: time => {
          return (
            time.getTime() <
            new Date(DateUtils.safeDate(this.startMoth)).getTime()
          )
        }
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
